import { combineReducers } from 'redux';
import authReducer from './authReducer';
import themeReducer from './themeReducer';
import membersReducer from './membersReducer';
import systemUsersReducer from './systemUsersReducer';
import sharedDataReducer from './sharedDataReducer';
import reportsReducer from './reportsReducer';
import notificationReducer from './notificationReducer';
import jiraReducer from './jiraReducer';
import userReducer from './userReducer';

const reducers = combineReducers({
  auth: authReducer,
  theme: themeReducer,
  members: membersReducer,
  systemUsers: systemUsersReducer,
  sharedData: sharedDataReducer,
  reports: reportsReducer,
  notifications: notificationReducer,
  jira: jiraReducer,
  user: userReducer
});

export default reducers;
